import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-1c42dcbd"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "user-contest"
};
var _hoisted_2 = {
  class: "list-container"
};
import ContestList from '../../common/components/ContestList/index.vue';
import ContestTabs from '../../common/components/ContestTabs/index.vue';
import { AildUserExamService } from '@/services/contest/2025/aild.service';
import { useService } from '@kaokei/use-vue-service';
import { UserService } from '@@/services/user.service';
import { computed, onUnmounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { StateMap } from '../../common/js/utils';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var aildUserExamService = useService(AildUserExamService);
    var userService = useService(UserService);
    var route = useRoute();
    var contestData = computed(function () {
      return aildUserExamService.userExamList || [];
    });
    var pageStatus = computed(function () {
      if (StateMap[route.query.state]) {
        return StateMap[route.query.state].status;
      }
      return 1;
    });
    watch(pageStatus, function (newStatus) {
      aildUserExamService.setAttrs({
        status: newStatus,
        activityTag: 'aild-2025'
      });
      aildUserExamService.search();
    }, {
      immediate: true
    });
    onUnmounted(function () {
      aildUserExamService === null || aildUserExamService === void 0 ? void 0 : aildUserExamService.clearTimer();
    });
    return function (_ctx, _cache) {
      var _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_spin, {
        size: "large",
        tip: "正在加载数据中...",
        spinning: _unref(aildUserExamService).loading,
        delay: 120
      }, {
        default: _withCtx(function () {
          return [_createVNode(ContestTabs), _createElementVNode("div", _hoisted_2, [_createVNode(ContestList, {
            list: _unref(contestData),
            pagination: false
          }, null, 8, ["list"])])];
        }),
        _: 1
      }, 8, ["spinning"])]);
    };
  }
});